// extracted by mini-css-extract-plugin
export default {"shareButtonRoot":"Button_shareButtonRoot__uCkbJ","historyButtonRoot":"Button_historyButtonRoot__GvVRI"};